import {
  buildRichTooltip,
  tooltipField,
  tooltipTitle,
} from "../../../../../../../../../../../_shared/_logic/rich-tooltips"

export { RICH_TOOLTIP_CLASS as USER_ACTION_TOOLTIP_CLASS } from "../../../../../../../../../../../_shared/_logic/rich-tooltips"

const tooltip = (title: string, action: string, effect: string, hint?: string) =>
  buildRichTooltip([
    tooltipTitle(title),
    tooltipField("Was passiert", action),
    tooltipField("Auswirkung", effect),
    tooltipField("Hinweis", hint),
  ])

export type UserTableAction =
  | "open"
  | "suspend"
  | "unsuspend"
  | "resend-invitation"
  | "revoke-invitation"

export const userActionTooltip = (action: UserTableAction): string => {
  if (action === "open") {
    return tooltip(
      "Benutzer öffnen",
      "Öffnet die Benutzerdaten dieser Person.",
      "Änderungen dort wirken sich auf den Zugriff dieser Person aus.",
    )
  }

  if (action === "suspend") {
    return tooltip(
      "Benutzer sperren",
      "Sperrt den Zugriff dieser Person auf die Organisation.",
      "Die Person kann sich danach nicht mehr in dieser Organisation anmelden.",
      "Die Rolle bleibt erhalten; die Sperre lässt sich jederzeit aufheben.",
    )
  }

  if (action === "unsuspend") {
    return tooltip(
      "Benutzer entsperren",
      "Hebt die Sperre dieser Person auf.",
      "Die Person erhält wieder Zugriff mit ihrer bisherigen Rolle.",
    )
  }

  if (action === "resend-invitation") {
    return tooltip(
      "Einladung erneut senden",
      "Sendet eine neue Einladung an diese E-Mail-Adresse.",
      "Die bisherige Einladung wird dabei ungültig.",
      "Die gewählte Rolle bleibt unverändert.",
    )
  }

  return tooltip(
    "Einladung zurückziehen",
    "Zieht die offene Einladung zurück.",
    "Der Link aus der Einladung kann danach nicht mehr angenommen werden.",
  )
}
